import Dashboard from "../features/dashboard/Dashboard";

export default function DashboardPage(){
    return <Dashboard/>;
}